module.exports = __webpack_public_path__ + "static/media/gb.4df1e7ea.svg";